import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-generic-iframe-modal',
  templateUrl: './generic-iframe-modal.component.html',
  styleUrls: ['./generic-iframe-modal.component.scss']
})
export class GenericIframeModal implements OnInit {

  url: SafeResourceUrl;

  innerHeight: any = '850px';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<GenericIframeModal>,
  ) {

    if (data) {
      if (data.url) {
        let currentUrl = this.transform(`${data.url}`);
        this.url = currentUrl
      }

    }

  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

}
